<template>
  <div class="couponV3Dialog" :style="`background-image:url(${data.icon});`">
    <div class="couponV3DialogContent" >
      <div class="content-detail">
        <div class="content" :style="`color:${data.paramColor}`">
          <span class="num">{{data.discountValueV2}}</span>
          <span v-if="data.discountType==='FREE_DAY'" class="ext">天</span><span  class="ext" v-else >元</span>
        </div>
        <div class="endtime animate-tag" v-if="data.expiredContent">{{ data.expiredContent }}</div>
      </div>
      <div class="btn couponV3Dialog" :class="`caseId-${data.relationId?data.relationId:data.caseId}`" data-sensors-click @click="handleButtonClick()"></div>

      <van-count-down :time="autoJumpTime*10e2" @finish="countDownEnd" v-if="showCountDown" style=" font-size: 0.48rem; color: #FFFFFF; visibility: hidden;">
        <template #default="timeData">
          ({{timeData.seconds+1}}s)
        </template>
      </van-count-down>
    </div>
  </div> 
</template>

<script>
import dayjs from 'dayjs'

export default {
  data () {
    return {
      visible: true,
      showCountDown: false
    }
  },
  props: {
    caseid: {
      type: [String, Number],
      default: ''
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    couponEndTime () {
      return dayjs(this.data.couponEndTime).format('MM月DD日')
    },
    autoJumpTime () {
      return this.data.autoJumpTime || 2
    }
  },
  mounted () {
    if (this.data.autoJump === 'Y') {
      this.showCountDown = true
    }
  },
  methods: {
    open () {
      this.visible = true
    },
    close () {
      this.visible = false
      this.$emit('close')
    },
    countDownEnd () {
      this.$sensors.track('popup_auto_click', { caseid: this.data.relationId ? `v3popUp-${this.data.relationId}` : this.caseid })
      this.visible = false
      this.showCountDown = false
      this.handleButtonClick()
    },
    handleButtonClick () {
      const { mainButtonSkip, couponV3Type } = this.data
      const query = {
        skipType: mainButtonSkip,
        couponSerialNo: this.data.couponSerialNo
      }

      if (couponV3Type === 'FREE') {
        query.cacheCouponSerialNo = 'Y'
      }
      this.$router.push({
        path: '/middle/coupon',
        query
      })
    },
    show () {}
  }
}
</script>

<style lang="less" scoped>
@import "../../../../assets/less/mixin.less";

  .couponV3Dialog {
    width: 620px;
    height: 750px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    margin: 0 auto;
    position: relative;
    .couponV3DialogContent {
      .btn {  
        position: absolute;
        width: 440px;
        height: 80px;
        top:540px;
        left: 100px;
      }
      .content-detail {
        position: absolute;
      
        top:300px;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        .content {
          .num {
            font-size: 120px;
            line-height: 120px;
            font-family: DIN-Medium;
            font-weight: 500;
          }
          .ext {
            font-family:  PingFangSC-Medium, PingFang SC;
            font-size:48px;
            font-weight: 500px;
            vertical-align: 10px;
          }
        }
        .endtime {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 24px;
          color: #A13227;
          line-height: 33px;
        }
      }
    }
     
  }
</style>